import { Modal, Text, Stack, Button, Divider, Flex } from '@mantine/core';
import { isMobile } from 'react-device-detect';

interface ProfileIncompleteModalProps {
  opened: boolean;
  onClose: () => void;
  onProceed: () => void;
  isLoading?: boolean;
}

const PROFILE_VIEW_URL = '/app/workerProfile/view';

/**
 * Modal warning the user that their profile is under 90% complete
 * User can choose to edit their profile or proceed anyway
 */
function ProfileIncompleteModal({
  opened,
  onClose,
  onProceed,
  isLoading = false,
}: ProfileIncompleteModalProps) {
  const handleEditProfile = () => {
    window.open(PROFILE_VIEW_URL, '_blank');
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton
      title={
        <Text fw={700} size="xl">
          Heads Up!
        </Text>
      }
    >
      <Stack gap="md" align="center" ta="center">
        <Text>
          Your profile is under 90%. You&apos;re 3x more likely to be contacted
          if it&apos;s near 100%!
        </Text>

        <Divider w="100%" />

        <Flex justify="center" gap="sm">
          <Button
            variant="filled"
            onClick={handleEditProfile}
            size={isMobile ? 'xs' : 'sm'}
          >
            Edit your profile
          </Button>
          <Button
            variant="default"
            onClick={onProceed}
            loading={isLoading}
            size={isMobile ? 'xs' : 'sm'}
          >
            Proceed without editing
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}

export default ProfileIncompleteModal;
